import React from 'react';
import { scoringData } from '../data/nflData';

export const ScoringTable = () => {
  return (
    <div className="overflow-x-auto" data-testid="scoring-table">
      <table className="scoring-table">
        <thead>
          <tr>
            <th>Tipo de Jugada</th>
            <th className="text-center">Puntos</th>
            <th>Explicación</th>
          </tr>
        </thead>
        <tbody>
          {scoringData.map((item, index) => (
            <tr key={index}>
              <td className="font-semibold text-white">{item.type}</td>
              <td className="text-center">
                <span className="points">{item.points}</span>
              </td>
              <td>{item.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const ScoringCard = ({ type, points, description, icon: Icon }) => {
  return (
    <div className="tactical-card p-6 rounded-r-xl group hover:border-l-orange-500 transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          {Icon && (
            <div className="w-10 h-10 bg-slate-700 rounded-lg flex items-center justify-center group-hover:bg-emerald-500/20 transition-colors duration-300">
              <Icon className="w-5 h-5 text-emerald-400" />
            </div>
          )}
          <h3 
            className="text-xl font-bold text-white uppercase tracking-wide"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            {type}
          </h3>
        </div>
        <span 
          className="text-4xl font-black text-orange-500"
          style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
        >
          {points}
        </span>
      </div>
      <p className="text-slate-400 leading-relaxed">{description}</p>
    </div>
  );
};

export default ScoringTable;
